import React, {PropTypes} from 'react';
const s = require('./subscribe.scss');
import {Link} from 'react-router';

const Subscribe = ({subscribed}) => {
  if (subscribed === 'sending') {
    return (
      <div className={s.subscribeWrapper}>
        <div className={s.content}>
          <h3 className={s.title} data-hook="subscribe-page-title">Subscribing you to<br/>Wix Updates & Releases...</h3>
          <div className={s.closeBtnWrapper}>
            <Link to="/">
              <svg className={s.closesvg} height="19.94" width="19.969" viewBox="0 0 19.969 19.94">
                <path id="Close" d="M250.275,3881.01l-1.082-1.08-8.9,8.9-8.9-8.9-1.082,1.08,8.9,8.9-8.9,8.9,1.082,1.08,8.9-8.9,8.9,8.9,1.082-1.08-8.9-8.9Z" transform="translate(-230.312 -3879.94)"/>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    );
  } else if (subscribed === 'success') {
    return (
      <div className={s.subscribeWrapper}>
        <div className={s.content}>
          <h3 className={s.title} data-hook="subscribe-page-title">Thanks For<br/>Subscribing!</h3>
          <label className={s.nextTimeText}>{`You'll get an email next time there's an update.`}</label>
          <div className={s.doneWrapper}>
            <Link to="/" className={s.done}>
              Done
            </Link>
          </div>
        </div>
      </div>
    );
  } else if (subscribed === 'failure') {
    return (
      <div className={s.subscribeWrapper}>
        <div className={s.content}>
          <h3 className={s.title} data-hook="subscribe-page-title">Opss... something went wrong!<br/>Please try again later.</h3>
          <div className={s.doneWrapper}>
            <Link to="/" className={s.done}>
              Done
            </Link>
          </div>
        </div>
      </div>
    );
  }
};

Subscribe.propTypes = {
  subscribed: PropTypes.string.isRequired
};

export default Subscribe;



// WEBPACK FOOTER //
// ./components/partial/Subscribe/Subscribe.js